/**
 * Testers never see which individual reviewer handles their submission, only the
 * department. The tester API therefore returns `reviewingDepartments` instead of
 * the reviewer ids in `reviewedBy`.
 */

export const NO_REVIEWING_DEPARTMENT_LABEL = "Ej tilldelad";

export const getReviewingDepartments = (submission) => {
  if (!Array.isArray(submission?.reviewingDepartments)) return [];

  return [
    ...new Set(
      submission.reviewingDepartments
        .filter(Boolean)
        .map((name) => String(name).trim())
        .filter(Boolean)
    ),
  ];
};

export const resolveReviewingDepartmentLabel = (submission) => {
  const departments = getReviewingDepartments(submission);
  return departments.length > 0
    ? departments.join(", ")
    : NO_REVIEWING_DEPARTMENT_LABEL;
};
